// @ts-nocheck
import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";
import {
  LS_TOKEN,
} from "@/legacy/helpersModule";
export function HRIframeShell({ baseUrl, onLogout }) {
  const param = (typeof window.HR_TOKEN_QUERY_PARAM === "string" && window.HR_TOKEN_QUERY_PARAM.trim()) || "token";
  const qs = window.HR_PASS_SWAR_TOKEN === true ? (() => {
    const t = localStorage.getItem(LS_TOKEN);
    if (!t) return "";
    const sep = baseUrl.includes("?") ? "&" : "?";
    return sep + param + "=" + encodeURIComponent(t);
  })() : "";
  const src = baseUrl + qs;
  return (
    <div className="min-h-dvh safe-bottom flex flex-col bg-white">
      <div className="shrink-0 flex items-center justify-between gap-3 px-4 py-3 border-b border-slate-200 bg-white text-ink-900 safe-top safe-x">
        <span className="text-sm font-bold tracking-tight">AIRA · HR</span>
        <button type="button" onClick={onLogout} className="text-xs font-bold text-ink-400 hover:text-ink-900 underline">Logout</button>
      </div>
      <iframe title="HR workspace" src={src} className="flex-1 w-full min-h-0 border-0 bg-white" style={{ height: "calc(100dvh - 52px)" }} />
    </div>
  );
}

